import styled from 'styled-components';

export const FooterContainer = styled.footer`
  background-color: ${({ theme }) => theme.elsie.colors.inverse.canvas.soft};
  display: flex;
  justify-content: center;
  padding: ${({ theme }) => theme.elsie.dimension[40]} 0;
  width: 100%;
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1340px;
  width: 100%;
`;

export const FooterMain = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.elsie.dimension[64]};
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.elsie.dimension[12]};
`;

export const FooterSide = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.elsie.dimension[20]};
`;

export const FooterTitle = styled.span`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.soft};
  text-transform: uppercase;
  font-size: 12px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
`;

export const FooterLink = styled.a`
  text-decoration: none;
  width: fit-content;
  background-color: transparent;
  border-radius: ${({ theme }) => theme.elsie.borderRadius.md};
  padding: ${({ theme }) => theme.elsie.dimension[8]} ${({ theme }) => theme.elsie.dimension[12]};
  color: ${({ theme }) => theme.elsie.colors.inverse.content.onInteractive.faint};
  font-size: 13px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.semiBold};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
  :hover {
    background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.soft.hovered};
  }
  :active {
    background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.soft.pressed};
  }
`;

export const FooterSideLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.elsie.dimension[4]};
`;

export const FooterSocials = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

export const FooterSocialLink = styled.a`
  color: ${({ theme }) => theme.elsie.colors.inverse.content.onInteractive.soft};
  border-radius: ${({ theme }) => theme.elsie.borderRadius.md};
  background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.soft.default};
  width: ${({ theme }) => theme.elsie.dimension[32]};
  height: ${({ theme }) => theme.elsie.dimension[32]};
  display: flex;
  justify-content: center;
  align-items: center;
  :hover {
    background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.soft.hovered};
  }
  :active {
    background-color: ${({ theme }) => theme.elsie.colors.inverse.interactive.soft.pressed};
  }
`;

export const FooterApps = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.elsie.dimension[8]};
`;

export const FooterAppLink = styled.a`
  & img {
    width: 100px;
    height: 30px;
  }
`;

export const FooterLogo = styled.figure`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 9px;
  margin: 0;
`;

export const FooterSeal = styled.img`
  width: 104px;
  height: auto;
`;

export const FooterCopy = styled.span`
  display: block;
  color: ${({ theme }) => theme.elsie.colors.inverse.content.soft};
  font-size: 12px;
  font-weight: ${({ theme }) => theme.elsie.fontWeight.regular};
  line-height: ${({ theme }) => theme.elsie.lineHeight.lg};
  letter-spacing: ${({ theme }) => theme.elsie.letterSpacing.sm};
`;
